<template>
  <v-row dense>
    <v-col>
      <v-card :elevation="permitEdit ? '' : 0">
        <v-container fluid>
          <v-row dense v-if="isEditing">
            <v-col>
              <PrescriptionFormNewMed
                :attendance="attendance"
                :prescriptionId="prescriptionId"
                :prescriptionNewMed="prescriptionNewMed"
                :prescriptionInput="prescriptionInput"
                :refreshList="refreshList"
                :newMedPresets="newMedPresets"
                :prescriptionFrequencies="prescriptionFrequencies"
                :prescriptionPeriods="prescriptionPeriods"
                :prescriptionHowLongs="prescriptionHowLongs"
                :hideForm="hideForm"
                :addNewItem="addNewItem"
                :disabled="disabled"
              />
            </v-col>

            <v-col cols="auto" class="mt-3">
              <v-btn small icon color="light-blue" @click="isEditing = !isEditing">
                <v-icon>eva-checkmark-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-row align="center" dense v-else>
            <v-col>
              <span class="font-weight-bold"> {{ index + 1 }} - </span>
              {{ prescriptionNewMed.description }}
            </v-col>

            <v-col cols="auto" v-if="permitEdit">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    :attrs="attrs"
                    v-on="on"
                    @click="isEditing = !isEditing"
                    :disabled="disabled"
                  >
                    <v-icon>eva-edit-outline</v-icon>
                  </v-btn>
                </template>

                <span>
                  Editar
                </span>
              </v-tooltip>
            </v-col>

            <v-col cols="auto" v-if="permitEdit">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    :attrs="attrs"
                    v-on="on"
                    @click="deletePrescriptionItem"
                    :disabled="disabled"
                  >
                    <v-icon>eva-trash-outline</v-icon>
                  </v-btn>
                </template>

                <span>
                  Excluir
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import PrescriptionFormNewMed from "@/components/prescription/form/new_med.vue";

  import DELETE_PRESCRIPTION_NEW_MED from "@/graphql/prescription/delete_prescription_new_med.gql";

  export default {
    name: "PrescriptionNewMed",
    props: {
      attendance: Object,
      prescriptionId: String,
      prescriptionNewMed: Object,
      prescriptionInput: Object,
      refreshList: Function,
      index: Number,
      permitEdit: {
        type: Boolean,
        default: true,
      },
      newMedPresets: {
        type: Array,
        default: () => [],
      },
      prescriptionFrequencies: {
        type: Array,
        default: () => [],
      },
      prescriptionPeriods: {
        type: Array,
        default: () => [],
      },
      prescriptionHowLongs: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hideForm: Function,
      addNewItem: Function,
    },
    components: {
      PrescriptionFormNewMed,
    },
    data() {
      return {
        isEditing: false,
      };
    },
    methods: {
      deletePrescriptionItem() {
        if (this.disabled) return;

        this.apolloMutate({
          mutation: DELETE_PRESCRIPTION_NEW_MED,
          variables: {
            prescriptionNewMedId: this.prescriptionNewMed.id,
          },
        }).then(() => {
          this.refreshList();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
